import { Skeleton as SkeletonDs, Typography } from "@packages/ds";
import styled from "styled-components";

import ListGroupDefault from "Components/ListGroup";

export const ListGroup = styled(ListGroupDefault)`
  box-sizing: border-box;
  padding: 24px 32px;
`;

export const TopRow = styled.div<{ smallMargin: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ smallMargin }) => (smallMargin ? "4px" : "24px")};
`;

export const SubTitle = styled(Typography.BodyText)`
  margin-bottom: 24px;
  color: var(--mode-text-neutral-default);
`;

export const ItemTop = styled(Typography.BodyText)`
  color: var(--mode-text-neutral-default);
`;

export const ItemBottom = styled(Typography.BodyText)`
  color: var(--mode-text-neutral-weakest);
`;

export const Group = styled.div`
  display: grid;
  grid-template-rows: repeat(2, auto);
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const LegacyRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;

export const Rows = styled.div`
  display: grid;
  gap: 16px;
`;

export const Skeleton = styled(SkeletonDs)`
  display: flex;
  gap: 20px;
`;

export const SkeletonCard = styled(SkeletonDs.Card)`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 20px;
  height: 56px;
`;

export const SkeletonCardEnvName = styled(SkeletonCard)`
  height: 48px;
`;
